(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categories"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", (event) => {
        const slider = document.querySelector('.categories-slider.swiper');
        if(!slider) return;
        
        const isMobileSlider = slider.dataset.mobileSlider === 'true';
        const isDesktopSlider = slider.dataset.desktopSlider === 'true';
        let swiper = null;
        
        function initSlider() {
            const isMobile = window.innerWidth < 992;
            const shouldInit = (isMobile && isMobileSlider) || isDesktopSlider;
            
            if (shouldInit && !swiper) {
                swiper = new Swiper(slider, {
                    slidesPerView: "auto",
                    loop: false,
                    freeMode: true,
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    spaceBetween: isMobile ? 12 : 24,
                });
            } else if (!shouldInit && swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        }
        
        initSlider();
        window.addEventListener('resize', initSlider);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-section"]) return;
  try {
    
  function media_view(){
    let session_val = sessionStorage.getItem("col-view");
    if(session_val != null){
      if(session_val == 'Product'){
        var pro_grid_filter_wrap = document.querySelector('.pro-grid-filter a');
        pro_grid_filter_wrap.setAttribute('data-id','Model');
        pro_grid_filter_wrap.textContent = 'Model';
        pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn').setAttribute('data-id',session_val);
        pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn span').textContent = session_val;
      }
    }
  }
  // document.addEventListener("DOMContentLoaded", (event) => {
  //   // console.log("dom");
  //   // document.getElementById('collection-grid').classList.remove('init-loading');
  //   document.querySelectorAll('.product-item.init-loading-item').forEach(item_load => {
  //     item_load.classList.remove('init-loading-item');
  //   });
  // });
  document.addEventListener("readystatechange", (event) => {
    // console.log("readystatechange");
    media_view();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }    		
              var productslider=[];
              document.querySelectorAll('.product-carousel').forEach(function(Element,index){    
                let productid = Element.dataset.id;
                let outer_carousel = Element.closest('.carousel-rowouter');
                let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
                let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
                let swiperObject={
                  loop:eval(Element.dataset.loop),
                  slidesPerView: "auto",
                  navigation: {
                    nextEl:nextbutton,
                    prevEl:prevbutton,
                  },
                };    
                productslider[productid]=new Swiper(Element,swiperObject);
              }); 
              if(typeof quickAddButton == 'function'){
              quickAddButton();
              }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
